document.documentElement.classList.remove('no-js');
if('IntersectionObserver'in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){document.documentElement.classList.add('vtx-reveal-ready');const vtxRevealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-revealed');vtxRevealObserver.unobserve(entry.target)}}),{rootMargin:'0px 0px -8% 0px',threshold:.08});document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-reveal-section]').forEach(section=>vtxRevealObserver.observe(section)))}
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-localization-select]').forEach(select=>select.addEventListener('change',()=>{try{localStorage.setItem('vtx_localization_selected','true')}catch{}select.form?.requestSubmit()}));const controls=document.querySelector('[data-localization-controls][data-auto-language="true"]');const language=controls?.querySelector('select[name="locale_code"]');if(!language)return;let manuallySelected=false;try{manuallySelected=localStorage.getItem('vtx_localization_selected')==='true'}catch{}if(manuallySelected)return;const available=[...language.options].map(option=>option.value.toLowerCase());const preferred=(navigator.languages||[navigator.language]).map(value=>String(value).toLowerCase());const match=preferred.map(value=>available.find(code=>code===value)||available.find(code=>code.split('-')[0]===value.split('-')[0])).find(Boolean);if(match&&match!==language.value.toLowerCase()){language.value=language.options[available.indexOf(match)].value;language.form?.requestSubmit()}});
document.addEventListener('DOMContentLoaded',()=>{
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer=window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if(false){
    document.querySelectorAll('.vtx-card,.vtx-collection-card,.vtx-mosaic-card,.vtx-editorial-showcase__feature').forEach(card=>{
      card.classList.add('vtx-3d-card');
      let frame;
      card.addEventListener('pointermove',event=>{
        window.cancelAnimationFrame(frame);
        frame=window.requestAnimationFrame(()=>{
          const bounds=card.getBoundingClientRect();
          const x=(event.clientX-bounds.left)/bounds.width-.5;
          const y=(event.clientY-bounds.top)/bounds.height-.5;
          card.style.setProperty('--vtx-tilt-x',`${y*-5}deg`);
          card.style.setProperty('--vtx-tilt-y',`${x*7}deg`);
          card.style.setProperty('--vtx-shine-x',`${(x+.5)*100}%`);
          card.style.setProperty('--vtx-shine-y',`${(y+.5)*100}%`);
        });
      });
      card.addEventListener('pointerleave',()=>{
        window.cancelAnimationFrame(frame);
        card.style.setProperty('--vtx-tilt-x','0deg');
        card.style.setProperty('--vtx-tilt-y','0deg');
      });
    });
  }
  const menuButton=document.querySelector('[data-menu-toggle]');
  const mobileMenu=document.querySelector('[data-mobile-menu]');
  const closeMenu=()=>{if(menuButton&&mobileMenu){mobileMenu.classList.remove('is-open');menuButton.setAttribute('aria-expanded','false');}};
  if(menuButton&&mobileMenu){
    menuButton.addEventListener('click',()=>{const open=mobileMenu.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(open));});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu();});
  }

  const searchDialog=document.querySelector('[data-search-dialog]');
  const predictiveInput=document.querySelector('[data-predictive-input]');
  const predictiveResults=document.querySelector('[data-predictive-results]');
  let predictiveTimer;
  let predictiveController;
  const openSearch=event=>{
    if(!searchDialog||typeof searchDialog.showModal!=='function')return;
    event?.preventDefault();
    closeMenu();
    searchDialog.showModal();
    window.setTimeout(()=>predictiveInput?.focus(),40);
  };
  const closeSearch=()=>{if(searchDialog?.open)searchDialog.close();};
  document.querySelectorAll('[data-search-open]').forEach(link=>link.addEventListener('click',openSearch));
  document.querySelectorAll('[data-search-close]').forEach(button=>button.addEventListener('click',closeSearch));
  if(searchDialog){
    searchDialog.addEventListener('click',event=>{if(event.target===searchDialog)closeSearch();});
    searchDialog.addEventListener('close',()=>{predictiveInput?.setAttribute('aria-expanded','false');});
  }
  if(predictiveInput&&predictiveResults){
    predictiveInput.addEventListener('input',()=>{
      window.clearTimeout(predictiveTimer);
      predictiveController?.abort();
      const term=predictiveInput.value.trim();
      if(term.length<2){predictiveResults.innerHTML='';predictiveInput.setAttribute('aria-expanded','false');return;}
      predictiveTimer=window.setTimeout(async()=>{
        predictiveController?.abort();
        predictiveController=new AbortController();
        const url=new URL(predictiveInput.dataset.predictiveUrl,window.location.origin);
        url.searchParams.set('q',term);
        url.searchParams.set('resources[type]','product');
        url.searchParams.set('resources[limit]','5');
        url.searchParams.set('section_id','predictive-search');
        try{
          const response=await fetch(url,{signal:predictiveController.signal});
          if(!response.ok)throw new Error('Predictive search failed');
          const text=await response.text();
          const html=new DOMParser().parseFromString(text,'text/html');
          const source=html.querySelector('#vtx-predictive-results');
          if(predictiveInput.value.trim()!==term)return;
          predictiveResults.innerHTML=source?source.innerHTML:'';
          predictiveInput.setAttribute('aria-expanded','true');
        }catch(error){if(error.name!=='AbortError'){predictiveResults.innerHTML='';predictiveInput.setAttribute('aria-expanded','false');}}
      },220);
    });
  }

  const toast=document.querySelector('[data-toast]');
  let toastTimer;
  const showToast=message=>{
    if(!toast||!message)return;
    toast.textContent=message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer=window.setTimeout(()=>toast.classList.remove('is-visible'),2400);
  };
  document.addEventListener('submit',async event=>{
    const form=event.target.closest?.('[data-quick-add-form]');
    if(!form)return;
    event.preventDefault();
    const button=form.querySelector('[data-quick-add-button]');
    if(!button||button.disabled)return;
    const defaultLabel=button.dataset.defaultLabel||button.textContent;
    button.disabled=true;
    button.classList.add('is-loading');
    try{
      const endpoint=form.dataset.ajaxUrl||`${form.action}.js`;
      const response=await fetch(endpoint,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const payload=await response.json();
      if(!response.ok)throw new Error(payload.description||payload.message||'Unable to add item');
      button.textContent=button.dataset.addedLabel||defaultLabel;
      const cartResponse=await fetch(form.dataset.cartUrl||'/cart.js',{headers:{Accept:'application/json'}}).catch(()=>null);
      if(cartResponse?.ok){
        const cartData=await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cartData.item_count);
      }
      showToast(button.dataset.addedLabel||defaultLabel);
      window.setTimeout(()=>{button.textContent=defaultLabel;},1600);
    }catch(error){showToast(error.message);}
    finally{button.disabled=false;button.classList.remove('is-loading');form.querySelector('[data-card-option]')?.dispatchEvent(new Event('change'));}
  });

  document.querySelectorAll('[data-variant-select]').forEach(select=>{
    const productSection=select.closest('[data-product-section]');
    const updateVariant=()=>{
      const option=select.options[select.selectedIndex];
      if(!option)return;
      const price=option.dataset.price||'';
      const compare=option.dataset.compare||'';
      const available=option.dataset.available==='true';
      const priceNode=productSection?.querySelector('[data-product-price]');
      const compareNode=productSection?.querySelector('[data-product-compare]');
      const addButton=productSection?.querySelector('[data-add-button]');
      const addLabel=productSection?.querySelector('[data-add-label]');
      const mobilePrice=productSection?.querySelector('[data-mobile-price]');
      const mobileButton=productSection?.querySelector('[data-mobile-atc-button]');
      const gallerySelect=productSection?.querySelector('[data-gallery-variant-select]');
      const galleryPurchaseId=productSection?.querySelector('[data-gallery-purchase-id]');
      const galleryAdd=productSection?.querySelector('[data-gallery-add]');
      const galleryAddLabel=productSection?.querySelector('[data-gallery-add-label]');
      const galleryPrice=productSection?.querySelector('[data-gallery-price]');
      const galleryCompare=productSection?.querySelector('[data-gallery-compare]');
      const gallery=productSection?.querySelector('[data-product-gallery]');
      const mediaId=option.dataset.mediaId;
      if(priceNode)priceNode.textContent=price;
      if(mobilePrice)mobilePrice.textContent=price;
      if(compareNode){compareNode.textContent=compare;compareNode.hidden=!compare;}
      if(addButton)addButton.disabled=!available;
      if(mobileButton)mobileButton.disabled=!available;
      const label=available?productSection.dataset.addText:productSection.dataset.soldText;
      if(addLabel)addLabel.textContent=label;
      if(mobileButton)mobileButton.textContent=label;
      productSection.querySelectorAll('[data-stock-label]').forEach(node=>node.hidden=!available);
      productSection.querySelectorAll('.shopify-payment-button').forEach(node=>node.hidden=!available);
      const nextUrl=new URL(location.href);nextUrl.searchParams.set('variant',option.value);history.replaceState({},'',nextUrl);
      if(gallerySelect&&gallerySelect.value!==option.value)gallerySelect.value=option.value;
      if(galleryPurchaseId){galleryPurchaseId.value=option.value;galleryPurchaseId.dispatchEvent(new Event('change',{bubbles:true}));}
      if(galleryAdd)galleryAdd.disabled=!available;
      if(galleryAddLabel)galleryAddLabel.textContent=label;
      if(galleryPrice)galleryPrice.textContent=price;
      if(galleryCompare){galleryCompare.textContent=compare;galleryCompare.hidden=!compare;}
      if(gallery&&mediaId){
        const media=gallery.querySelector(`[data-media-id="${mediaId}"]`);
        if(media)gallery.scrollTo({left:Math.max(0,media.offsetLeft-14),behavior:'smooth'});
      }
    };
    select.addEventListener('change',updateVariant);
    updateVariant();
  });

  document.querySelectorAll('[data-size-guide-toggle]').forEach(button=>{
    button.addEventListener('click',()=>{
      const section=button.closest('[data-product-section]');
      const guide=section?.querySelector('[data-size-guide]');
      if(!guide)return;
      guide.hidden=!guide.hidden;
      section.querySelectorAll('[data-size-guide-toggle][aria-expanded]').forEach(toggle=>toggle.setAttribute('aria-expanded',String(!guide.hidden)));
    });
  });

  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const gallery=section.querySelector('[data-product-gallery]');
    const slides=[...section.querySelectorAll('[data-gallery-slide]')];
    const dots=[...section.querySelectorAll('[data-gallery-dot]')];
    const current=section.querySelector('[data-gallery-current]');
    const gallerySelect=section.querySelector('[data-gallery-variant-select]');
    const formSelect=section.querySelector('[data-variant-select]');
    const setActiveSlide=index=>{
      dots.forEach((dot,dotIndex)=>{const active=dotIndex===index;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',String(active));});
      if(current)current.textContent=String(index+1);
    };
    dots.forEach((dot,index)=>dot.addEventListener('click',()=>slides[index]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})));
    if(gallery&&slides.length>1&&'IntersectionObserver'in window){
      const galleryObserver=new IntersectionObserver(entries=>{const visible=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];if(visible)setActiveSlide(slides.indexOf(visible.target));},{root:gallery,threshold:[.45,.6,.75]});
      slides.forEach(slide=>galleryObserver.observe(slide));
    }
    if(gallerySelect&&formSelect){
      const initialMediaId=gallerySelect.options[gallerySelect.selectedIndex]?.dataset.mediaId;
      const initialMedia=initialMediaId?gallery?.querySelector(`[data-media-id="${initialMediaId}"]`):null;
      if(initialMedia)gallery.scrollTo({left:Math.max(0,initialMedia.offsetLeft-14)});
      gallerySelect.addEventListener('change',()=>{
        formSelect.value=gallerySelect.value;
        formSelect.dispatchEvent(new Event('change',{bubbles:true}));
      });
    }
    /* Fix (Sep 13): filter the gallery to only the selected color's photos instead of leaving every
       color visible in one unfiltered strip. Only activates when the product actually has per-slide
       color data (set in main-product.liquid); products without a Color option, or where colors
       haven't been tagged to images yet, keep the previous scroll-to behavior untouched. */
    const galleryTotal=section.querySelector('[data-gallery-total]');
    const applyColorFilter=()=>{
      if(!formSelect||!gallery||!slides.length)return;
      const hasColorData=slides.some(slide=>slide.dataset.variantColor);
      if(!hasColorData)return;
      const option=formSelect.options[formSelect.selectedIndex];
      const color=option?.dataset.variantColor||'';
      if(!color)return;
      let firstVisibleIndex=-1;
      let visibleCount=0;
      slides.forEach((slide,index)=>{
        const match=slide.dataset.variantColor===color;
        slide.hidden=!match;
        if(dots[index])dots[index].hidden=!match;
        if(match){visibleCount++;if(firstVisibleIndex===-1)firstVisibleIndex=index;}
      });
      if(galleryTotal)galleryTotal.textContent=String(visibleCount||slides.length);
      if(firstVisibleIndex>-1){
        setActiveSlide(firstVisibleIndex);
        gallery.scrollTo({left:Math.max(0,slides[firstVisibleIndex].offsetLeft-14)});
      }
    };
    if(formSelect){
      formSelect.addEventListener('change',applyColorFilter);
      applyColorFilter();
    }
    const addButton=section.querySelector('[data-add-button]');
    const mobileBar=section.querySelector('[data-mobile-atc]');
    const mobileButton=section.querySelector('[data-mobile-atc-button]');
    const form=section.querySelector('.vtx-product-form');
    const quantities=[...section.querySelectorAll('input[name="quantity"]')];
    quantities.forEach(input=>input.addEventListener('input',()=>quantities.forEach(other=>{if(other!==input)other.value=input.value})));
    const available=!(section.querySelector('[data-add-button]')?.disabled);
    section.querySelectorAll('.shopify-payment-button').forEach(node=>node.hidden=!available);
    if(mobileButton&&form)mobileButton.addEventListener('click',()=>form.requestSubmit());
    if(addButton&&mobileBar&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{const open=!entry.isIntersecting;mobileBar.classList.toggle('is-visible',open);mobileBar.setAttribute('aria-hidden',String(!open));mobileBar.inert=!open;});},{threshold:.15});
      observer.observe(addButton);
    }
  });

  const filterPanel=document.querySelector('[data-filter-panel]');
  const filterButtons=document.querySelectorAll('[data-filter-toggle]');
  const setFilters=open=>{
    if(!filterPanel)return;
    filterPanel.classList.toggle('is-open',open);
    filterButtons.forEach(button=>button.setAttribute('aria-expanded',String(open)));
    if(window.innerWidth<=820)document.body.style.overflow=open?'hidden':'';
  };
  filterButtons.forEach(button=>button.addEventListener('click',()=>setFilters(!filterPanel?.classList.contains('is-open'))));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&filterPanel?.classList.contains('is-open'))setFilters(false);});
  document.querySelectorAll('[data-sort-select]').forEach(select=>select.addEventListener('change',()=>select.form?.submit()));

  document.querySelectorAll('[data-card-variants]').forEach(script=>{
    const form=script.closest('form');
    if(!form)return;
    let variants=[];
    try{variants=JSON.parse(script.textContent);}catch(e){return;}
    const idInput=form.querySelector('[data-card-variant-id]');
    const addBtn=form.querySelector('[data-card-add]');
    const selects=Array.from(form.querySelectorAll('[data-card-option]')).sort((a,b)=>Number(a.dataset.cardOption)-Number(b.dataset.cardOption));
    const addLabel=addBtn?addBtn.textContent.trim():'';
    function currentOptions(){return selects.map(s=>s.value);}
    function findVariant(){
      const opts=currentOptions();
      return variants.find(v=>{
        const vOpts=[v.option1,v.option2,v.option3].filter(o=>o!==null&&o!==undefined);
        return opts.length===vOpts.length&&opts.every((val,i)=>vOpts[i]===val);
      });
    }
    function update(){
      const variant=findVariant();
      if(variant){
        idInput.value=variant.id;
        idInput.disabled=false;
        if(addBtn){
          addBtn.disabled=!variant.available;
          addBtn.textContent=variant.available?addLabel:addBtn.dataset.soldOutLabel||addBtn.textContent;
        }
        idInput.dispatchEvent(new Event('change',{bubbles:true}));
      }else if(addBtn){
        idInput.value='';idInput.disabled=true;
        addBtn.disabled=true;
      }
    }
    selects.forEach(s=>s.addEventListener('change',update));
    update();
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  const body=document.body;
  if(!body||body.dataset.vtxAdaptive!=='true'||body.dataset.vtxDesignMode==='true')return;
  let adaptiveStarted=false;
  const startAdaptive=()=>{
    if(adaptiveStarted)return;
    adaptiveStarted=true;
    const memoryDays=Math.max(7,Number(body.dataset.vtxMemoryDays)||30);
    const maxAge=memoryDays*86400000;
    const profileKey='vtx_adaptive_profile_v1';
    const recentKey='vtx_recently_viewed_v1';
    const now=Date.now();
    const safeParse=(value,fallback)=>{try{return JSON.parse(value)||fallback}catch{return fallback}};
    const safeGet=key=>{try{return localStorage.getItem(key)}catch{return null}};
    const profile=safeParse(safeGet(profileKey),{categories:{}});
    profile.categories=profile.categories||{};
    Object.keys(profile.categories).forEach(key=>{const entry=profile.categories[key];if(!entry||now-(entry.updated||0)>maxAge)delete profile.categories[key];});
    const saveProfile=()=>{try{localStorage.setItem(profileKey,JSON.stringify(profile))}catch{}};
    const normalizedCategories=node=>{
      const raw=node?.dataset?.adaptiveCategories||node?.dataset?.adaptiveCategory||'';
      return [...new Set(raw.split(',').map(value=>value.trim()).filter(Boolean))];
    };
    const categoryScore=category=>{
      const entry=profile.categories[category];
      if(!entry)return 0;
      const ageDays=Math.max(0,(now-(entry.updated||now))/86400000);
      return (entry.score||0)*Math.pow(.92,ageDays);
    };
    const recordCategory=(category,weight)=>{
      if(!category)return;
      const existing=profile.categories[category]||{score:0,updated:now};
      existing.score=Math.min(60,categoryScore(category)+weight);
      existing.updated=Date.now();
      profile.categories[category]=existing;
      saveProfile();
    };
    const emit=(name,detail={})=>document.dispatchEvent(new CustomEvent('vtx:adaptive-event',{detail:{name,...detail}}));
    const pageType=body.dataset.vtxPageType||'';
    if(pageType==='collection'&&body.dataset.vtxCategory)recordCategory(body.dataset.vtxCategory,2);

    const productView=document.querySelector('[data-adaptive-product-view]');
    if(productView){
      normalizedCategories(productView).forEach(category=>recordCategory(category,3));
      emit('product_view',{productId:productView.dataset.adaptiveProductId||'',categories:normalizedCategories(productView)});
      if(body.dataset.vtxRecentlyViewed==='true'){
        const recent=safeParse(safeGet(recentKey),[]).filter(item=>item&&now-(item.updated||0)<=maxAge&&String(item.id)!==String(productView.dataset.adaptiveProductId));
        recent.unshift({id:productView.dataset.adaptiveProductId,title:productView.dataset.adaptiveProductTitle,url:productView.dataset.adaptiveProductUrl,image:productView.dataset.adaptiveProductImage,price:productView.dataset.adaptiveProductPrice,categories:normalizedCategories(productView),updated:now});
        try{localStorage.setItem(recentKey,JSON.stringify(recent.slice(0,12)))}catch{}
      }
    }

    document.addEventListener('click',event=>{
      const collectionCard=event.target.closest('[data-adaptive-card]');
      if(collectionCard){normalizedCategories(collectionCard).forEach(category=>recordCategory(category,1));emit('collection_click',{categories:normalizedCategories(collectionCard)});}
      const productCard=event.target.closest('[data-adaptive-product]');
      if(productCard){normalizedCategories(productCard).forEach(category=>recordCategory(category,2));emit('product_click',{productId:productCard.dataset.adaptiveProductId||'',categories:normalizedCategories(productCard)});}
      const addButton=event.target.closest('[data-add-button],[data-quick-add-button],[data-mobile-atc-button]');
      if(addButton){const source=addButton.closest('[data-adaptive-product],[data-adaptive-product-view]');normalizedCategories(source).forEach(category=>recordCategory(category,5));emit('add_to_cart_intent',{productId:source?.dataset?.adaptiveProductId||'',categories:normalizedCategories(source)});}
    },{passive:true});

    const sortAdaptive=(container,selector)=>{
      if(!container)return;
      const items=[...container.querySelectorAll(selector)];
      if(items.length<2)return;
      const ranked=items.map((item,index)=>({item,index,score:Math.max(0,...normalizedCategories(item).map(categoryScore))}));
      if(!ranked.some(entry=>entry.score>=1))return;
      ranked.sort((a,b)=>b.score-a.score||a.index-b.index).forEach(entry=>container.appendChild(entry.item));
      const best=ranked[0];
      if(best.score>=2&&!best.item.querySelector('.vtx-adaptive-badge')){
        const badge=document.createElement('span');
        badge.className='vtx-adaptive-badge';
        badge.textContent=body.dataset.vtxPickedLabel||'Picked for you';
        best.item.appendChild(badge);
      }
    };
    document.querySelectorAll('[data-adaptive-collections] .vtx-grid--collections').forEach(grid=>sortAdaptive(grid,'[data-adaptive-card]'));
    document.querySelectorAll('[data-adaptive-products]').forEach(grid=>sortAdaptive(grid,'[data-adaptive-product]'));

    if(body.dataset.vtxRecentlyViewed==='true'){
      const section=document.querySelector('[data-recently-viewed-section]');
      const grid=section?.querySelector('[data-recently-viewed-grid]');
      const currentId=productView?.dataset?.adaptiveProductId||'';
      const recent=safeParse(safeGet(recentKey),[]).filter(item=>item&&now-(item.updated||0)<=maxAge&&String(item.id)!==String(currentId)).slice(0,4);
      if(section&&grid&&recent.length){
        const esc=value=>String(value||'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
        grid.innerHTML=recent.map(item=>`<article class="vtx-card vtx-recent-card"><a class="vtx-card__link" href="${esc(item.url)}"><div class="vtx-card__media">${item.image?`<img loading="lazy" src="${esc(item.image)}" alt="${esc(item.title)}">`:''}</div><div class="vtx-card__meta"><h3 class="vtx-card__title">${esc(item.title)}</h3>${item.price?`<div class="vtx-card__price">${esc(item.price)}</div>`:''}</div></a></article>`).join('');
        section.hidden=false;
      }
    }

    window.VTXAdaptive={getProfile:()=>JSON.parse(JSON.stringify(profile)),recordCategory,emit};
  };

  const privacyReady=()=>{
    const privacy=window.Shopify?.customerPrivacy;
    if(!privacy)return false;
    if(privacy.preferencesProcessingAllowed())startAdaptive();
    return true;
  };
  if(privacyReady())return;
  if(window.Shopify?.loadFeatures){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)privacyReady();});
  }
  document.addEventListener('visitorConsentCollected',event=>{if(event.detail?.preferencesAllowed===true)startAdaptive();});
});
